import {h, Component} from 'preact';
import DateTime from '/chat/src/common/js/lib/DateTime';
import lang from '/chat/src/languages/lang';
import style from './style.scss'
import {UserModel, TicketModel} from '/chat/src/redux/model'
import Customization from '/chat/src/redux/model/customization/model';
import {connect} from 'preact-redux';

import AutoresponseMeta from './Autoresponse'
import OfflineMessage from './OfflineMessage'
import OnlineFormular from './OnlineFormular'

class MetaMessage extends Component{
    renderFileMessage(entry){
        const meta = entry.meta
        const isImage = (/\.(gif|jpg|jpeg|tiff|png)$/i).test(meta.details.file_name)
        return (
            <div>
                <div style={{color: 'black', marginBottom: '10px'}}>
                    {entry.entry_body}
                </div>
                <div>
                    {isImage && <img style={{width: '60%', height: 'auto'}}src={meta.details.url}/>}
                </div>
                <a download={meta.details.file_name} target="_blank" href={meta.details.url}>
                    {meta.details.file_name}
                </a>

            </div>
        )
    }
    render() {
        const entry = this.props.entry.toJS()
        const user = this.props.user.toJS()
        var message;
        if(!entry.meta) return;
        const meta = entry.meta
        const type = meta.type;
        switch(meta.type){
            case 'file':
                message = this.renderFileMessage(entry);
                break;
            case 'autoresponse':
                return <AutoresponseMeta user={user} entry={entry}/>
            case 'autoresponse_customer':
                switch(meta.details.type){
                    case 'reply_by_email':
                        message = this.props.language.get("AutoresponseCustomerReplyByEmail")
                        break;
                    default:
                        message = ''
                        break;
                }
                break;
            case 'offline_message':
                return <OfflineMessage entry={entry} />
            case 'online_formular':
                return <OnlineFormular entry={entry} />
            default:
                message = entry.entry_body
        }
        return  <div class='meta-message'>{message}</div>
    }
}


export default connect(
    state => {
        return {
        language: Customization.getLanguage(state)
    }})(MetaMessage)



// WEBPACK FOOTER //
// ./routes/Chat/Chat/MetaMessage/MetaMessage.js